import { NgModule, LOCALE_ID, APP_INITIALIZER } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';
import { DatePipe } from '@angular/common';

import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { ToastrModule } from 'ngx-toastr';
import { MatLegacyDialogModule } from '@angular/material/legacy-dialog';

import { AbstractModule } from 'app/abstract/abstract.module';
import { SharedModule } from 'app/shared/shared.module';
import { AuthService } from 'app/shared/auth/auth.service';
import { AuthInterceptor } from 'app/services/auth-interceptor';
import { initializeIcon } from 'app/lib/icons/initialize.icon';
import { IconsService } from 'app/lib/icons/icons.service';
import { inicializarFeatureFlags } from 'app/services/feature-flag/initialize.feature-flag';
import { AbFeatureFlag } from 'app/abstract/services/feature-flag.abstract';
import { inicializarPostHog } from 'app/services/posthog/initialize.posthog';
import { IdentificacaoPostHogService } from 'app/services/posthog/identificacao-posthog.service';
import { AbPostHog } from 'app/abstract/services/posthog.abstract';

export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http);
}

/** Providers e módulos globais compartilhados entre o AppModule e o LeafHostModule. */
@NgModule({
  imports: [
    HttpClientModule,
    ToastrModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    AbstractModule,
    SharedModule,
    // Necessário aqui (e não no CorrespondenciaModule) porque ReportService é provido
    // na raiz via AbstractModule e injeta MatDialog direto no construtor.
    MatLegacyDialogModule,
  ],
  // Re-exporta SharedModule para que os módulos importadores (AppModule, LeafHostModule)
  // tenham acesso aos componentes e diretivas declarados nele (NavbarComponent, SidebarComponent, etc.).
  exports: [SharedModule],
  providers: [
    AuthService,
    // CommonModule só registra o pipe `| date` para templates; injeção via construtor
    // (usada em componentes migrados como leaf) precisa de um provider explícito.
    DatePipe,
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: APP_INITIALIZER, useFactory: initializeIcon, deps: [IconsService], multi: true },
    { provide: APP_INITIALIZER, useFactory: inicializarFeatureFlags, deps: [AbFeatureFlag, AuthService], multi: true },
    // Compartilhado (e não no AppModule) porque a folha bootstrapa seu próprio módulo:
    // ancorado no AppModule, o SDK nunca inicializava nas rotas migradas e o serviço
    // ficava em no-op, descartando todo evento em silêncio.
    { provide: APP_INITIALIZER, useFactory: inicializarPostHog, deps: [AbPostHog, IdentificacaoPostHogService], multi: true },
    { provide: LOCALE_ID, useValue: window.navigator.languages[0] },
  ],
})
export class CoreProvidersModule {}
